module.exports = __webpack_public_path__ + "img/JoeWahba_O_25.6642ada8.jpg";